module.exports = __webpack_public_path__ + "assets/img/efficacy.1dd82330.png";